import { Pipe, PipeTransform } from '@angular/core';
import { LunaClaimValues } from '../../../app/models/user-identity.model';
import { AuthService } from '../../../app/services/auth.service';

@Pipe({
    name: 'systemPermission',
    standalone: false
})
export class SystemPermissionPipe implements PipeTransform {

    constructor(
        public _authService: AuthService
    ) { }

    transform(value: string, args?: any): boolean {
        if (!value)
            return false;

        return !!this._authService.hasSystemPermission(value);
    }
}
